module.exports = __webpack_public_path__ + "img/logoStep-default.5447a988.png";